// extracted by mini-css-extract-plugin
export default {"root":"styles_root__DT5rN","content":"styles_content__RrcC4"};